import { connect } from "react-redux";
import SectorsList from "./SectorsList";
import {
	addmportAssortiment,
	getAllClients,
	getAllRetailers,
} from "../../../redux/actions/clientActions";
import { getSectorsList, init } from "redux/actions/sectorsActions";
import { updateUserSector } from "../../../redux/actions/userActions.js";
import { getPDCS } from "../../../redux/actions/sectorsActions";

const mapStateToProps = (state, ownProps) => {
	return {
		sectorsList: state.sectors.sectorsList,
		page: state.sectors.page,
		pages: state.sectors.pages,
		pageSize: state.sectors.pageSize,
		nbItems: state.sectors.sectorsList.length,
		managerUsersList: state.sectors.managerUsersList,
		userInfos: state.userInfos,
		currentClientLabel: (state.currentClient || {}).label,
		updateLoading: state.user.updateLoading,
		//clientsList: state.client.surveyManager.clientsList,
		//retailersList: state.client.surveyManager.retailersList,
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		addmportAssortiment: body => {
			dispatch(addmportAssortiment(body));
		},
		getAllClients: () => {
			dispatch(getAllClients());
		},
		getAllRetailers: () => {
			dispatch(getAllRetailers());
		},
		getNext: page => {
			const nextPage = page;
			dispatch(getSectorsList({ page: nextPage }));
		},
		init: () => dispatch(init()),
		getPDCS: () => dispatch(getPDCS()),
		updateUserSector: (data, page) => dispatch(updateUserSector(data, page)),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SectorsList);



// WEBPACK FOOTER //
// src/containers/metier/sectors/SectorsContainer.js